import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import PulseLoader from 'react-spinners/PulseLoader';
import API from '../../configAPI';
import ProductItem from './ProductItem';
import ButtonMore from '../partials/ButtonMore';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';
import FormRequest from './FormRequest';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class ProductDetails extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            totalproduc: JSON.parse(localStorage.getItem('total_car')) ? JSON.parse(localStorage.getItem('total_car')) : [] ,
            totalprecio: JSON.parse(localStorage.getItem('total_prec')) ? JSON.parse(localStorage.getItem('total_prec')) : [] ,
            listaCarrito: JSON.parse(localStorage.getItem('Carrito')) ? JSON.parse(localStorage.getItem('Carrito')) : [] ,
            id:cookies.get("id")?cookies.get("id"):1,
            loading: true,
            product: {
                brand: {},
                bim: {},
                sub_category: {
                    category: {
                        item :{

                        }
                    }
                },
                provider: {},
                product_images: [],
                product_resources: [],
                tags: []

            },
            products_provider : [],
            products_sub_categ : [],
            products_format_bim:[],
        }
    }
    componentDidMount(){
        this.getProduct();
        window.scrollTo(0, 0);
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.product !== prevProps.match.params.product){
            this.getProduct();
            window.scrollTo(0, 0);
        }
    }
    getProduct = () =>{
        this.setState({loading: true});

        API.PRODUCTS(`product/${this.props.match.params.product}`)
        .then(resp =>{
            this.setState({
                product: resp.data.product,
                products_provider : resp.data.products_provider,
                products_sub_categ : resp.data.products_sub_category,
                products_format_bim : resp.data.formats_bim,
                loading: false
            });
           // console.log(resp.data);
            
        })
        .catch(err =>{
            console.log(err);
        });
    }

    downloadResource = (id) => {
        API.PRODUCTS(`product/download-resource/${id}`)
        .then(resp =>{
            window.open(resp.data.url_path);
        })
        .catch(err => {
            console.log(err);
        });
    }

    downloadBim= (id) => {
        API.PRODUCTS.post(`product/download-bim/${id}`,
            {
            id_user:this.state.id
            })
        .then(resp =>{
            //console.log(resp.data);
            window.open(resp.data.url_path);
            
        })
        .catch(err => {
            console.log(err);
        });
    }

    getMainImage = (images, prod_name) =>{

        // Buscar imagen principal
        const main_image = images.find(image =>{
            return image.is_main === 1;
        });

        // Validar si existe la imagen principal
        if(main_image){
            // Rertornar imagen principal
            return (<img src={main_image.thumbnail} alt={prod_name} title={prod_name}/>);
        }

        // En caso de que no exista la imagen principal
        // Retornar imagen del indice 0
        return (<img src={images[0].thumbnail} alt={prod_name} title={prod_name}/>);

    }

    render(){
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
          };
        return (
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">

                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    
                    <div className="row d-flex flex-wrap mt-3">
                        <div className="col-xs-12 col-md-7">
                            <div className="d-inline">
                                <h4>{this.state.product.name}</h4><h5><small>{this.state.product.brand.name}</small></h5>
                            </div>
                            <div className="row">
                                <section className="col-xs-12 col-md-9">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                    <li className="breadcrumb-item" aria-current="page">
                                        <Link to={`/productos/${this.state.product.sub_category.category.item.slug}`} 
                                            className="minitext black"> {this.state.product.sub_category.category.item.name} 
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/productos/${this.state.product.sub_category.category.item.slug}/${this.state.product.sub_category.category.slug}`} 
                                            className="minitext black">{this.state.product.sub_category.category.name}
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/productos/${this.state.product.sub_category.category.item.slug}/${this.state.product.sub_category.category.slug}/${this.state.product.sub_category.slug}`} 
                                            className="minitext black">{this.state.product.sub_category.name}
                                        </Link>
                                    </li>
                                    </ol>
                                </nav>   
                                </section>
                                <section className="col-xs-12 col-md-3 pt-1">
                                    <a href="#SharingModal" className="btn btn-secondary btn-sm float-right" data-toggle="modal" >
                                        <i className="fas fa-share-alt"></i>
                                    </a>
                                    {this.state.product.bim.length>0?
                                        <a href="#div_bim" className="btn btn-warning btn-sm float-right" style={{marginRight:"8px"}}   >
                                        BIM
                                        </a>
                                    :
                                    ""}
                                    

                                    <div className="modal" id="SharingModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalCenterTitle">Compartir</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            </div>
                                            <div className="modal-body">
                                            <div className="container-fluid">
                                                <div className="row d-flex flex-nowrap justify-content-center">                          
                                                <section className="col-md-3 text-center">
                                                    <a  className="social face" 
                                                        href={`https://www.facebook.com/sharer.php?u=${CONFIG.app_url +'producto/'+ this.state.product.slug}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-facebook-f"></i>
                                                    </a>
                                                </section>
                                                <section className="col-md-3 text-center">
                                                    <a  className="social tweet" 
                                                        href={`https://twitter.com/intent/tweet?url=${CONFIG.app_url +'producto/'+ this.state.product.slug}&text=${this.state.product.name}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-twitter"></i>
                                                    </a>
                                                </section>
                                                <section className="col-md-3 text-center">
                                                    <a  className="social linked" 
                                                        href={`https://www.linkedin.com/shareArticle?mini=true&url=${CONFIG.app_url +'producto/'+ this.state.product.slug}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-linkedin-in"></i>
                                                    </a>
                                                </section>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="mt-3">
                                <div className="col-md-12">
                                        <Slider {...settings}>
                                            
                                            {this.state.product.product_images.map((image,index) =>(
                                                 image.is_main===0?
                                                    <img src={image.url_image} key={index} alt={this.state.product.name}/>
                                                    :
                                                 ""
                                            
                                                
                                            ))}

                                               {this.state.product.product_images.map((image,index) =>(
                                                 image.is_main===1?
                                                    <img src={image.url_image} key={index} alt={this.state.product.name}/>
                                                    :
                                                 ""
                                                 
                                                
                                            ))}

                                        </Slider>
                                </div>
                            </div>
                           {/* <div className="row mt-3">
                                <section className="col-12">
                                    <h5>Resumen del producto</h5>
                                    <table className="table gray">            
                                        <tbody>
                                        <tr>                
                                            <td width="22%">Producto:</td>
                                            <td width="78%">{this.state.product.name}</td>
                                        </tr>
                                        <tr>               
                                            <td>Marca: </td>
                                            <td>{this.state.product.brand.name}</td>
                                        </tr>
                                        <tr>                
                                            <td>Proveedor:</td>
                                            <td>{this.state.product.provider.name}</td>
                                        </tr>
                                        
                                        {this.state.product.price > this.state.product.fair_price && this.state.product.fair_price > 0 ?
                                            <tr>               
                                                <td>Precio feria: </td>
                                                <td>
                                                   <s className="text-danger"> S/ {(this.state.product.price /100).toLocaleString(navigator.language, { minimumFractionDigits: 2 })} </s>
                                                   &nbsp;
                                                    S/ {(this.state.product.fair_price /100).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                                </td>
                                            </tr>
                                            :
                                            this.state.product.price > 0 ? 
                                            <tr>               
                                                <td>Precio: </td>
                                                <td>S/ {(this.state.product.price /100).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</td>
                                            </tr>
                                            : ''
                                        }

                                        </tbody>
                                    </table>
                                </section>
                                    </div>*/}
                            <div className="row mt-2 mb-3" >
                                <section className="col-12" id="div_bim">
                                <br></br><br></br>
                                <h5>Información:</h5>
                                <div dangerouslySetInnerHTML={{__html: this.state.product.details}}>
                                    
                                </div>
                                </section>
                            </div>
                            {this.state.product.bim.length>0?    
                            <div  className="row mt-5">
                            <section className="col-12">
                            <h5>Archivos BIM</h5>  
                            <div className="list-group">
                                {this.state.products_format_bim.map((format,index)=>(
                                    <a type="button"  data-toggle="modal" data-target="#exampleModalbim" key={index}>
                                    <li className="list-group-item list-group-item-action" key={index}>
                                    <div className="row">
                                        
                                        <div className="col-sm-11 col-9">
                                            <img src={format.url_icon} width="20px"></img>
                                            <span style={{marginLeft:"1%"}}>{format.name}</span>
                                        </div>

                                        <div className="col-sm-1 col-3">
                                            
                                            <button  className="btn btn-outline-secondary btn-sm"><span >{format.count} &nbsp;  </span>
                                                 <i className="fas fa-download"></i>
                                            </button>
                                        </div>            
                                    </div>
                                    </li> 
                                    </a>
                                ))} 
                            </div>

                                <div className="modal fade " id="exampleModalbim" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" style={{textAlign:'center',width:"100%"}} id="exampleModalLabel">DESCARGAR BIM/CAD</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{background:'white',color:'black'}}>
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                            <div className="accordion" id="accordionExample">
                                            {this.state.products_format_bim.map((format,index)=>(
                                                <div className="card" key={index}>
                                                    <div className="card-header" id={"headingOne"+index}>
                                                    <h2 className="mb-0">
                                                        <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target={"#collapseOne"+index} aria-expanded="true" aria-controls={"collapseOne"+index}>
                                                        <img src={format.url_icon} width="20px"></img> {format.name}

                                                        <spam style={{color:"black",float:"right"}}>{format.count}&nbsp;<i className="far fa-file" ></i></spam>
                                                        </button>
                                                    </h2>
                                                    </div>

                                                    <div id={"collapseOne"+index}  className="collapse show" aria-labelledby={"headingOne"+index} data-parent="#accordionExample">
                                                    <div className="card-body">
                                                    <div className="list-group">
                                                    {format.bim.map((bim,index)=>(
                                                            <a onClick={() => this.downloadBim(bim.id)}  key={index}>
                                                            <li className="list-group-item list-group-item-action" key={index}>
                                                            <div className="row">
                                                                
                                                                <div className=" col-9">
                                                                    <img src={format.url_icon} width="20px"></img>
                                                                    <span style={{marginLeft:"1%"}}>{bim.file_name}</span>
                                                                </div>
                        
                                                                <div className=" col-3">
                                                                    
                                                                    <button  className="btn btn-outline-secondary btn-sm"><span >{bim.peso} &nbsp;  </span>
                                                                        <i className="fas fa-download"></i>
                                                                    </button>
                                                                </div>            
                                                            </div>
                                                            </li> 
                                                            </a>
                                                    ))}
                                                    </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            ))}

                                            </div>
                                    
                                    </div>
                                    
                                    </div>
                                </div>
                                </div>


                            <br></br><br></br>
                            </section>
                        </div>
                            :
                            ""
                        }

                            
                            {this.state.product.product_resources.length > 0 ?
                                <div className="row mt-5">
                                    <section className="col-12">
                                    <h5>Catálogos disponibles:</h5>  
                                    <div className="list-group">
                                        {this.state.product.product_resources.map((resource,index)=>(
                                            <li className="list-group-item list-group-item-action" key={index}>
                                            <div className="row">
                                                <div className="col-11">{resource.title}</div>

                                                <div className="col-1">
                                                    <button onClick={() => this.downloadResource(resource.id)} className="btn btn-outline-secondary btn-sm">
                                                        <i className="fas fa-download"></i>
                                                    </button>
                                                </div>            
                                            </div>
                                            </li>
                                        ))} 
                                    </div>
                                    </section>
                                </div>
                                :
                                <div className="bg-gray">
                                    <small>No hay catálogos disponibles</small>
                                </div>
                            }


                        </div>
                        <div className="col-xs-12 col-md-5 bg-gray">
                            <div className="row">
                                <section className="col-12">
                                    <div className="d-inline"> <h4>{this.state.product.provider.name}</h4> </div>
                                    <div className="d-flex justify-content-between">
                                        <section className="row col-4">
                                            <Link to={`/empresa/${this.state.product.provider.slug}`}>
                                            <img src={this.state.product.provider.url_logo} className="img-fluid" alt={this.state.product.provider.name}/>
                                            </Link>
                                        </section>
                                        <section className="col-8 align-self-center">                
                                            <span className="minitext"> <i className="fas fa-map-marker-alt"></i> {this.state.product.provider.address}</span><br/>
                                            <span className="minitext"><i className="fas fa-phone"></i> {this.state.product.provider.phone_number}</span><br/>
                                            <span className="minitext"><i className="fas fa-globe"></i> <a href={`${this.state.product.provider.url_web}`} target="_blank" rel="noopener noreferrer"> Visitar sitio Web</a></span>
                                        </section>
                                    </div>
                                </section>
                            </div>
                            {this.state.product.stock==0 ?
                            <div className="mt-4">
                            
                                {this.state.loading === false &&
                                    <FormRequest 
                                        product_id={this.state.product.id}
                                        product_name={this.state.product.name}
                                    />
                                }
                             </div>  
                             :
                                <div className="mt-4">
                                <h3>{this.state.product.name}</h3>
                                
                                <p><strong>Marca: </strong>{this.state.product.brand.name}</p>  
                                
                               
                               {this.state.product.descuento>0?
                            
                                <span className="precio_prod">S/. {Number(this.state.product.fair_price).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>    
                                :<span className="precio_prod">{this.state.product.price==0 ? "" : "S/. " + Number(this.state.product.price).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>
                                }

                                {this.state.product.descuento>0?
                                    
                                    <span className="fair_precio_prod">S/. {Number(this.state.product.price).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>     
                                    : ""
                                }
                                    <br/>
                                
                                {this.state.product.descuento>0?
                                <span className="descuento_pd">- {this.state.product.descuento} DTO </span> 
                                : ""
                                }

                            </div>
                            } 
                            <div className="row mt-4">
                            <section className="col-12">
                            <div id={"div_inbtn"+this.state.product.id} className={ (this.state.product.stock == 0) ? "d_none" : localStorage.getItem("total"+this.state.product.id)==null?"btn-i-car":"d_none" }>
                            <input type="Number" id={"cant"+this.state.product.id} defaultValue="1" min="1" max={this.state.product.stock} disabled={ (this.state.product.stock <= 0) ? true : false }  ></input>
                            <button onClick={ this.agregarProducto.bind(this) } id={"btn"+this.state.product.id} className="boton_car" disabled={this.state.product.stock==0 ? true : localStorage.getItem("total"+this.state.product.id)==null ? false :true}>Añadir al Carrito <i className=""><img className="card_i"  src="/assets/car.png" width="5%"></img></i> </button>
                              
                            </div>
                            <a href="/shoppingcart"  > <p id={"btn_ver"+this.state.product.id} className={ (this.state.product.stock <= 0) ? "btn_carrito d_none" : localStorage.getItem("total"+this.state.product.id)==null?"d_none btn_carrito":" btn_carrito" }> <i className=""><img className="card_i"  src="/assets/car.png" width="5%"></img></i>Ver Carrito</p></a>
                            </section>
                            </div>
                           {/* <div className="row mt-4">
                            {this.state.loading === false &&
                                <Pasarelab
                                   product_name={this.state.product.name}
                                   product_id={this.state.product.id}
                                   priceunit={this.state.product.price}
                                   amount={this.state.product.price}
                                   min_stock={this.state.product.min_stock}
                                   fair_price={this.state.product.fair_price}
                                   stock={this.state.product.stock}
                                />
                            }
                        </div>*/}
                             <div className="row mt-4">
                                <section className="col-12">
                                <h5 className="text-center">¿Tienes dudas o consultas?</h5>  
                                <div className="row">
                                    
                                <div className="col-sm-6 col-xs-12">
                                    <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Escríbenos por Whatsapp</h5>
                                        <a className="card-text" href="https://api.whatsapp.com/send?phone=51981324180&amp;text=Hola%20quisiera%20informaci%C3%B3n%20sobre%20" style={{color:"#6C6C6C"}}  ><i className="fab fa-whatsapp"></i> 981 324 180</a>
                                        
                                    </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Escríbenos por email</h5>
                                        <a className="card-text" href="mailto:info@arquiproductos.com" style={{color:"#6C6C6C"}} ><i className="far fa-envelope"></i> info@arquiproductos.com</a>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                </section>
                             </div>

                             <div className="row mt-4">
                                <section className="col-12">
                                <h4 className="text-center">Medios de pago</h4> 
                                <br></br> 
                                <div className="row">
                                    
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/visa.png"></img> 
                                </div>
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/mastercard.png"></img> 
                                </div>
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/diners.png"></img> 
                                </div>
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/american.png"></img> 
                                </div>
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/unionpay.png"></img> 
                                </div>
                                <div className="col-sm-2 col-xs-2">
                                    <img src="/assets/ripley.png"></img> 
                                </div>
                                
                                </div>
                                </section>
                             </div>
                            <br></br>
                            <div className="row mt-4">
                                <section className="col-12">
                                    <div className="d-inline"><h5>Más productos de <strong>{this.state.product.provider.name}</strong></h5></div>
                                    <div className="row">
                                        {this.state.products_provider.map((prod,index) =>(
                                            <section className="col-3 mt-1 mb-1" key={index}>
                                                <Link to={`/producto/${prod.slug}`}>
                                                <div className="displayproduct text-center">
                                                    {prod.product_images.length > 0 ?
                                                    <img src={prod.product_images[0].thumbnail} alt={prod.name} title={prod.name}/>
                                                    :
                                                    <img src="/assets/default.jpg" alt="Default" title="Default"/>  
                                                    }
                                                </div>
                                                </Link>
                                            </section>
                                        ))}
                                    </div>
                                    <div className="d-flex pt-3 pb-3 justify-content-center">
                                        <ButtonMore href={`/empresa/${this.state.product.provider.slug}`}/>
                                    </div>
                                </section>
                            </div>

                        </div>
                    </div>
                    <div className="row col-md-12 mt-5">
                        <h5>Productos relacionados</h5>
                    </div>
                    <div className="row d-flex p-2 justify-content-start">
                        {this.state.products_sub_categ.length > 0 ?
                        <ProductItem products={this.state.products_sub_categ}/>
                        :
                        <small>No hay productos relacionados</small>
                        }
                    </div>
                </div>
            </div>
            
        )
    }
    agregarProducto = () =>{
        
        var total_car= JSON.parse(localStorage.getItem('total_car'));
        if  (total_car==null || total_car==0 ){
           var carrito =[];
        }else{
            var carrito = JSON.parse(localStorage.getItem('Carrito'));
        }

        let cantidad = document.querySelector("#cant"+this.state.product.id).value;
        if (Number(cantidad) <=0) {
            alert('Seleccione una cantidad válida');
            return
        }
        
        if(Number(this.state.product.stock) < Number(cantidad)){
            alert('Máxima existencia es: '+ this.state.product.stock);
        }else{
            
            /*this.state.productoCarrito.id =  id;*/
            
            /*this.state.productoCarrito.img =  this.props.img;*/
            var stock_disponible=this.state.product.stock-cantidad;
             localStorage.setItem("total"+this.state.product.id,stock_disponible);

            this.state.totalproduc = Number(total_car) + 1 ;
            localStorage.setItem("total_car",this.state.totalproduc);
            /*console.log(localStorage.getItem("total_car"));*/
            
            document.querySelector("#total_product").innerHTML = localStorage.getItem("total_car");


            
            document.querySelector("#btn"+this.state.product.id).disabled = true;
            document.querySelector("#div_inbtn"+this.state.product.id).style.display = "none";

            document.querySelector("#btn_ver"+this.state.product.id).style.display = "block";
           
/*
            localStorage.setItem("total"+id,stock_disponible);
            document.querySelector("#stock"+id).innerHTML = "stock: " + localStorage.getItem("total"+id);
     --
*/

               var producto= { 
                id : this.state.product.id,
                titulo : this.state.product.name,
                img : this.getMainImage(this.state.product.product_images, this.state.product.name),
                cantidad : Number(cantidad),
                precio : parseFloat(this.state.product.price),
                fair_precio:parseFloat(this.state.product.fair_price),
                descuento:this.state.product.descuento,
                proveedor : this.state.product.provider.name,
                stock:this.state.product.stock,
                envio:'Null',
                dias:'Null',
                distrito:'',
                distrito_id:'',
               };
               
              
                /*console.log(listaCarrito);
                console.log("-------------");*/
                
                carrito.push(producto);
                
                localStorage.setItem("Carrito",JSON.stringify(carrito));

           // }
           /*var carrito = JSON.parse(localStorage.getItem("Carrito"));
            
           var producto= this.state.productoCarrito;
            var carrito = carrito.push(producto);
            console.log(carrito);*/
          /* localStorage.setItem("Carrito",JSON.stringify(this.state.productoCarrito));*/
/*
          this.state.totalprecio = Number(this.state.totalprecio) + (this.state.product.price*cantidad) ;
          localStorage.setItem("total_prec",this.state.totalprecio);*/

          var total=0;
          var precio=0;
          for(let numero in carrito){
              if(Number(carrito[numero].descuento)>0){
                  precio= carrito[numero].fair_precio;
              }else{
                precio=carrito[numero].precio;
              }
              total = total + (carrito[numero].cantidad * precio);
          }
          localStorage.setItem("total_prec",total);
          localStorage.setItem("total_pago",-2);
          localStorage.setItem("total_envio",-2);   
           
        }
    }
}
export default ProductDetails;